<template>
  <base-modal ref="modal" size="md">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Edit Due Date</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-5">
        <base-date-picker :inline="true" label="Due Date" v-model="dueDate" required />
      </base-form>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-activity-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import moment from "moment";

export default {
  components: {
    InlineError,
  },
  name: "EditDueDate",
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      dueDate: null,
      todoItemId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(todoItemId, dueDate) {
      this.todoItemId = todoItemId;
      this.dueDate = moment(dueDate)
        .local()
        .format("M/D/YYYY");
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.todoItemId = null;
      this.dueDate = null;
      this.isFormValid = true;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      var dueDate = this.dueDate;
      var todoItemId = this.todoItemId;

      this.$axios
        .put(`/businesses/${this.businessId}/todo/${this.todoItemId}`, { dueDate: this.dueDate })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Due Date Updated",
            message: `Your due date was saved.`,
          });
          this.reset();
          this.hide();
          this.$emit("save", {
            todoItemId: todoItemId,
            dueDate: dueDate,
          });
        })
        .catch((err) => {
          this.errorTitle = `Error modifying due date`;
          this.errorMessage = "Sorry, we had trouble modifying this due date. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
